// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.v6jnb{display:flex;flex-direction:row;align-items:center}.JEFHF{width:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"newClientOption": `v6jnb`,
	"existingClientOption": `JEFHF`
};
export default ___CSS_LOADER_EXPORT___;
